import {Alert} from "@mui/material";
import BaseLayout from "qqq/layouts/BaseLayout";


interface Props
{
   message?: string;
}

NoApps.defaultProps = {
   message: null,
};

function NoApps({message}: Props): JSX.Element
{
   return (
      <BaseLayout>
         <Alert color="error">{message ?? "You do not have permission to access any apps."}</Alert>
      </BaseLayout>
   );
}

export default NoApps;
